import { render, staticRenderFns } from "./ChildSecondaryYN.vue?vue&type=template&id=40dfdf86"
import script from "./ChildSecondaryYN.vue?vue&type=script&lang=js"
export * from "./ChildSecondaryYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports